import { useState, useEffect, useRef, useCallback } from "react";
import { getGeneralSocialImpact } from "Explore/Services/Collaborations";

export const useGeneralSocialImpact = (params, isActive = false, enabled = true) => {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const lastFetchedParams = useRef(null);

  const executeFetch = useCallback(async (fetchParams, force = false) => {
    if (!enabled || !isActive || !fetchParams?.entity_id) {
      return;
    }

    const paramsString = JSON.stringify(fetchParams);
    if (!force && lastFetchedParams.current === paramsString) {
      return;
    }
    lastFetchedParams.current = paramsString;

    setIsLoading(true);
    setError(null);

    try {
      const res = await getGeneralSocialImpact(fetchParams);
      setData(res);
    } catch (err) {
      lastFetchedParams.current = null;
      console.error("Failed to fetch general social impact:", err);
      const errMsg =
        err?.response?.data?.detail?.errors?.[0]?.msg ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to load social impact data.";
      setError(errMsg);
    } finally {
      setIsLoading(false);
    }
  }, [enabled, isActive]);

  useEffect(() => {
    if (!enabled || !isActive || !params?.entity_id) {
      setData(null);
      setIsLoading(false);
      lastFetchedParams.current = null;
      return;
    }

    const paramsString = JSON.stringify(params);
    if (lastFetchedParams.current !== paramsString) {
      executeFetch(params);
    }
  }, [params, enabled, isActive, executeFetch]);

  const refetch = useCallback(() => {
    return executeFetch(params, true);
  }, [executeFetch, params]);

  return {
    data,
    isLoading,
    error,
    refetch,
  };
};

export default useGeneralSocialImpact;
